import React from 'react';
import { Chart } from 'react-google-charts';
import { Grid } from '@mui/material';

const PointChart = (props) => {
  const data = props.data;
  const chartSize = props.chartSize;
  const widthRate = parseFloat(props.widthRate);

  function dataValues() {
    if (data == null) {
      return [];
    }
    var values = [];
    for (var i = 1; i < data.length; i++) {
      values.push(data[i][1]);
    }
    values.sort(function (a, b) {
      return a - b;
    });
    return values;
  }

  const options = {
    legend: 'right',
    series: {
      0: { color: 'grey' },
    },
    color: (row) => (row[1] === 100 ? '#00FF00' : '#FF0000'),
    trendlines: {
      0: {
        type: 'linear',
        color: '#2e4665',
        lineWidth: 3,
        showR2: true,
        visibleInLegend: true,
      },
    },
    hAxis: { title: 'Günler', gridlines: { count: 0 } },
    pointSize: 10,
    pointShape: 'circle',
    dataLabels: {
      position: 'right',
      color: 'black',
      fontSize: 35,
      fontName: 'Verdana',
      callback: function (value) {
        return value + '%';
      },
    },
    vAxis: {
      title: 'Güvenlik Oranı',
      viewWindow: {
        max: 100,
        min: 0,
      },
      ticks: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      gridlines: {
        color: 'transparant',
      },
      pointsVisible: true,
      /* ticks: dataValues() */
    },
    annotations: {
      avoidOverlappingGridLines: true,
      textStyle: {
        fontSize: 15,
        italic: true,
        color: 'black',
      },
    },
  };

  const heightValue = (data[0].length / 2) * chartSize;
  return (
    <Grid item xs={widthRate == null ? 3.5 : widthRate}>
      <Chart
        height={heightValue < 300 ? 300 : heightValue}
        chartType="LineChart"
        data={data}
        options={options}
      />
    </Grid>
  );
};

export default PointChart;
